export const calculateExpression = (expression: string): number => {
  const formatted = expression.replace(/%/g, "/100");
  return eval(formatted);
};
